import * as React from 'react'
import { Content, Label, Wrapper, Message } from './FormInput.styles'

export type FormInputProps = {
  title: string,
  validationMessage?: string,
  isValid?: boolean,
  className?: string,
  inputId?: string,
  children?: React.ReactNode
}

const FormInput: React.FunctionComponent<FormInputProps> = ({
  title,
  validationMessage,
  isValid = false,
  children,
  className,
  inputId,
}) => (
  <Wrapper className={className}>
    <Label htmlFor={inputId}>{title}</Label>
    <Content>{children}</Content>
    {validationMessage && <Message isValid={isValid} data-invalid>{validationMessage}</Message>}
  </Wrapper>
)

export default FormInput
